import { render, staticRenderFns } from "./StatementLayout.vue?vue&type=template&id=71786ecb"
import script from "./StatementLayout.vue?vue&type=script&lang=js"
export * from "./StatementLayout.vue?vue&type=script&lang=js"
import style0 from "./StatementLayout.vue?vue&type=style&index=0&id=71786ecb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports